import React from "react";
import { FieldArray } from "formik";
import HoverIconButton from "components/HoverIconButton";
import { TOOLTIP_POSITION } from "utils/constants/ui";
import { getFieldDeleteItemName } from "utils/builder";
import FieldGroupContent from "./FieldGroupContent";
import classnames from "classnames";

const FieldGroup = ({
  label,
  collection,
  name,
  variableContext,
  dependencies,
  schema,
  template
}) => {
  const item = getFieldDeleteItemName(name);

  return (
    <FieldArray
      name={name}
      render={(arrayHelpers) => (
        <div>
          <div className="flex flex-row justify-between items-center pv3">
            <div className="f6 mb2 dib fw6">{label}</div>
            <HoverIconButton
              onClick={() => arrayHelpers.push(template)}
              tooltip={`Add ${item}`}
              tooltipPosition={TOOLTIP_POSITION.RIGHT}
              type="add"
            />
          </div>
          {collection &&
            Boolean(collection.length) &&
            collection.map((_, index) => (
              <div
                key={index}
                className={classnames("w-100 pt3", {
                  pt4: index
                })}
              >
                <FieldGroupContent
                  key={index}
                  name={name}
                  index={index}
                  arrayHelpers={arrayHelpers}
                  variableContext={variableContext}
                  dependencies={dependencies}
                  schema={schema}
                />
              </div>
            ))}
        </div>
      )}
    />
  );
};

export default FieldGroup;
